var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-row justify-center h-screen"},[_c('img',{staticClass:"w-40",attrs:{"src":_vm.logoURL}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }